<script>
  import { onMount } from "svelte";

  import Stats from "./stats.svelte";

  import { getContractType, getContractValue } from "../utils.js";

  export let chain;
  export let address;
  export let pieConf = {
    donut: true,
    width: 400,
    key: { field: 'payee', type: 'wallet' },
    value: { field: 'shares', type: 'number' }
  }
  export let columns = [
    { type: 'color', key: 'payee' },
    { type: 'wallet', key: 'payee', compact: 4 },
    { type: 'number', key: 'shares' },
    { type: 'nativeEther', key: 'releasable' },
    { type: 'nativeEther', key: 'released' }
  ]

  let data;

  const init = async () => {
    const totalShares = await getContractValue(chain, address, 'totalShares');
    let total = BigInt(0);
    let idx = 0;
    const stats = [];
    const contractType = await getContractType(address, chain);
    const stakeholder = contractType === 'Vault' ? 'payee' : 'stakeholders'
    while (total < totalShares) {
      const stakeholder = await getContractValue(chain, address, stakeholder, [ idx ]);
      const [ shares, released, releasable ] = await Promise.all([
        getContractValue(chain, address, 'shares', [ stakeholder ]),
        getContractValue(chain, address, 'released', [ stakeholder ]),
        getContractValue(chain, address, 'releasable', [ stakeholder ]),
      ]);
      stats.push({ stakeholder, shares, released, releasable });
      total += shares;
      idx++;
    }
    data = stats;
  }

  onMount(init);
</script>

{#if data}
  <Stats { data } { pieConf } { columns }>
    <svelte:fragment slot="copiable"><slot name="copiable">&#128203;</slot></svelte:fragment>
  </Stats>
{:else}
  Loading...
{/if}